export default "__VITE_ASSET__DxTzmxEc__"